<template>

    <v-app>
        <v-content>
            <v-overlay v-show="loader"  style="z-index: 9999">

                 <loader   object="#005d91" color1="#ffffff" color2="#007973" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" name="circular"></loader>
            
            </v-overlay>
            
            <Blank />
        </v-content>
    </v-app>
</template>

<script>

    import Blank from "./components/Blank"

    export default {
        name: 'App',

        components: {Blank},
        watch:{
            $route(){
                let vueBox=this;
                vueBox.loader=true;
                setTimeout(function(){
                    vueBox.loader=false;
                },3000)
            }
        },
        data() {
            return {
                loader: true
            }
        },
        mounted() {
            this.loader=false;
        }
    };
</script>

<style>
    .v-application{
        font-family: 'Montserrat' !important;
    }
    #side-menu a {
        font-family: 'Montserrat'!important;
        text-transform: uppercase;
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
        box-shadow: none;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot{
    box-shadow: none;
}
</style>
